import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getDatabase } from "firebase/database"; // For Realtime Database
import { getFirestore } from "firebase/firestore"; // For Firestore
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDH-_xPCiGz93eqcwB7ySIFiTN96CmrJUg",
  authDomain: "tghc-web.firebaseapp.com",
  projectId: "tghc-web",
  authDomain: "thegreathoneyco.com",
  storageBucket: "tghc-web.firebasestorage.app",
  messagingSenderId: "62262188195",
  appId: "1:62262188195:web:c2ba237335c05501e8c716",
  measurementId: "G-2J60PXF8W0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const database = getDatabase(app); // Realtime Database
const firestore = getFirestore(app); // Firestore
const auth = getAuth(app); 

const provider = new GoogleAuthProvider();

export { app, analytics, database, firestore, auth,provider, signInWithPopup };


